import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { RecoilRoot } from "recoil";
import RecoilNexus from "recoil-nexus";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import CustomToast from "./components/modal/CustomToast";
import ConfirmRecoilModal from "./components/modal/ConfirmRecoilModal";

import SocketService from "./components/socket/Socket";
import { Toaster } from "react-hot-toast";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

if (
  process.env.REACT_APP_ENV != undefined &&
  process.env.REACT_APP_ENV === "PRD"
) {
  console.log = () => null;
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <RecoilNexus />
        <SocketService />
        <BrowserRouter
          basename={
            process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : ""
          }
        >
          <App />
          <Toaster />
          {/* <ReactQueryDevtools /> */}
        </BrowserRouter>
        <CustomToast message="" type="success" />
        <ConfirmRecoilModal />
      </QueryClientProvider>
    </RecoilRoot>
  </>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
/*
if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'PRD') {
  serviceWorkerRegistration.register();
}
if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'DEV') {
  serviceWorkerRegistration.unregister();
}
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
